import _c from "../CodeSkeleton/CodeSkeleton.module.css";
import React, {Fragment} from "react";

const JavascriptBottomShell = () => {
    return <Fragment>
        <span className={_c.indent1}><span className={_c.gold}>boxparadeGraphX</span>(pieJson);</span>
        <span><span>{"})"}</span><span className={_c.orange}>;</span></span>
    </Fragment>
};

export default JavascriptBottomShell;